import { BoulderModel } from './boulder_model';
import { Grade } from './grade';

export class LineModel {
    #name: string;
    #grade: Grade | null;
    #thumbnail: string;
    #videos: Array<string>;
    #boulder: BoulderModel;
    #description: string | null;

    constructor(line: any, boulder: BoulderModel) {
        if (!line.name) {
            throw new Error('Line must have a name')
        }
        this.#name = line.name;
        if (line.grade) {
            try {
                this.#grade = new Grade(line.grade);
            }
            catch (e) {
                console.warn(`Invalid grade for line ${line.name}: ${line.grade}`);
                this.#grade = null;
            }
        }
        else {
            this.#grade = null;
        }

        this.#thumbnail = line.thumbnail;

        if (line.videos) {
            this.#videos = line.videos;
        }
        else {
            this.#videos = new Array<string>();
        }

        if (line.description) {
            this.#description = line.description;
        }
        else {
            this.#description = null;
        }

        this.#boulder = boulder;
    }

    get name() {
        return this.#name;
    }

    get grade() {
        return this.#grade;
    }

    get thumbnail() {
        return this.#thumbnail;
    }

    get videos() {
        return this.#videos;
    }

    get boulder() {
        return this.#boulder;
    }

    get description() {
        return this.#description;
    }
};
